import shareUrlService from '@/services/share-url-service';

let state = {
  turnPotSize: 100,
  turnBetSize: 100,
  numberOfOuts: 0,
  percentageOfPotWonOnRiverWhenYouHitAnOut: 50,
  numRiverCardsYoullBluff: 0,
  riverBluffSize: 100,
  probabilityOfGettingFoldOnRiver: 60,
  position: 'in position',
  probabilityThatOpponentBetsWhenYouCheck: 50,
  checkCall: false,
  opponentsTurnBetSize: 100,
  percentageOfPotWonAfterCheckCall: 50,
  percentageOfPotWonAfterTurnChecksThrough: 50,
};

let mutations = {
  setState: function (state, stateFromServer) {
    shareUrlService.setBreakevenPercentageForBluffingTheTurnStoreState(stateFromServer, state);
  },

  setTurnPotSize: function (state, turnPotSize) {
    state.turnPotSize = turnPotSize;
  },
  setTurnBetSize: function (state, turnBetSize) {
    state.turnBetSize = turnBetSize;
  },
  setNumberOfOuts: function (state, numberOfOuts) {
    state.numberOfOuts = numberOfOuts;
  },
  setPercentageOfPotWonOnRiverWhenYouHitAnOut: function (state, percentageOfPotWonOnRiverWhenYouHitAnOut) {
    state.percentageOfPotWonOnRiverWhenYouHitAnOut = percentageOfPotWonOnRiverWhenYouHitAnOut;
  },
  setNumRiverCardsYoullBluff: function (state, numRiverCardsYoullBluff) {
    state.numRiverCardsYoullBluff = numRiverCardsYoullBluff;
  },
  setRiverBluffSize: function (state, riverBluffSize) {
    state.riverBluffSize = riverBluffSize;
  },
  setProbabilityOfGettingFoldOnRiver: function (state, probabilityOfGettingFoldOnRiver) {
    state.probabilityOfGettingFoldOnRiver = probabilityOfGettingFoldOnRiver;
  },
  setPosition: function (state, position) {
    state.position = position;
  },
  setProbabilityThatOpponentBetsWhenYouCheck: function (state, probabilityThatOpponentBetsWhenYouCheck) {
    state.probabilityThatOpponentBetsWhenYouCheck = probabilityThatOpponentBetsWhenYouCheck;
  },
  setCheckCall: function (state, checkCall) {
    state.checkCall = checkCall;
  },
  setOpponentsTurnBetSize: function (state, opponentsTurnBetSize) {
    state.opponentsTurnBetSize = opponentsTurnBetSize;
  },
  setPercentageOfPotWonAfterCheckCall: function (state, percentageOfPotWonAfterCheckCall) {
    state.percentageOfPotWonAfterCheckCall = percentageOfPotWonAfterCheckCall;
  },
  setPercentageOfPotWonAfterTurnChecksThrough: function (state, percentageOfPotWonAfterTurnChecksThrough) {
    state.percentageOfPotWonAfterTurnChecksThrough = percentageOfPotWonAfterTurnChecksThrough;
  },
};

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
};

export { state, mutations };



// WEBPACK FOOTER //
// ./src/store/modules/breakeven-percentage-for-bluffing-the-turn/breakeven-percentage-for-bluffing-the-turn.js